import maplibregl from 'maplibre-gl';
require('../../node_modules/maplibre-gl/dist/maplibre-gl.css');

const key = 'w7CAT3JpYQ0BotwpAtkN';

// const testData = {
//     centrala: {
//         longitude: 16.9963362,
//         latitude: 51.1132741
//     },
//     lodz: {
//         longitude: 19.4091708,
//         latitude: 51.801352
//     },
//     opole: {
//         longitude: 17.8976427,
//         latitude: 50.6602429
//     },
//     jelenia: {
//         longitude: 15.7222588,
//         latitude: 50.9028665
//     },
// }

document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementById('map');
    const elCoordinatesEl = document.querySelectorAll('.js-map-coordinates > li');
    if (!el) {
        return;
    }

    const coordinates = [];
    let showDestinationBtn = true;

    elCoordinatesEl.forEach((item) => {
       if(item.dataset.longitude && item.dataset.latitude && !coordinates.find((element) => element.longitude === item.dataset.longitude && element.latitude === item.dataset.latitude)) {
           coordinates.push({
               longitude: item.dataset.longitude,
               latitude: item.dataset.latitude,
               address: item.dataset.fulladdress,
               default: item.classList.contains('is-active')
           });
       }
    });

    //is default in coordinates ?
    if(!coordinates.find((item) => item.default)) {
        coordinates[0].default = true;
    }

    if(coordinates.length === 0) {
        //default poland
        coordinates.push({
            latitude: 52.2370,
            longitude: 21.0175,
            default: true
        });
        showDestinationBtn = false;
    }

    const map = new maplibregl.Map({
        container: el, // container id
        style: `https://api.maptiler.com/maps/d8fa1eef-77ba-4294-a927-536251522843/style.json?key=${key}`, // style URL
        center: [
            coordinates.find((item) => item.default).longitude,
            coordinates.find((item) => item.default).latitude
        ], // starting position [lng, lat]
        zoom: 10, // starting zoom
    });

    map.addControl(new maplibregl.NavigationControl(), 'bottom-right');


    if(showDestinationBtn) {
        for (let location in coordinates) {

            const icon = document.createElement('div');
            icon.className = 'marker';
            icon.innerHTML = '';

            const button = document.createElement('button');
            button.innerText = "Wyznacz trasę";
            button.type = "button";
            button.className = "o-btn o-btn--black";

            button.addEventListener('click', () => {
                // window.open('https://www.google.com/maps/dir/?api=1&origin=&destination=' + coordinates[location].latitude + ',' + coordinates[location].longitude + '&travelmode=driving', '_blank');
                window.open('https://www.google.com/maps/dir/?api=1&origin=&destination=git ' + coordinates[location].address + '&travelmode=driving', '_blank');
            })

            new maplibregl.Marker({element: icon})
                .setLngLat([coordinates[location].longitude, coordinates[location].latitude])
                .addTo(map);

            new maplibregl.Marker({element: button})
                .setLngLat([coordinates[location].longitude, coordinates[location].latitude])
                .addTo(map);

        }

        window.jumpToPosition = function (longitude, latitude, zoom = 10) {
            map.jumpTo({
                center: [longitude, latitude],
                zoom
            });
        }
    }

});
